export default "__VITE_ASSET__DVgk2tkY__"